export default __webpack_public_path__ + "static/pragicts-partnerships-banner-cyber-security-be6476a5e85851f420322a675d0c5e19.jpg";